export default {
  init() {
    $('.order-line .reason-select select').each(function() {
      var $parent = $(this).closest('.order-line');

      $(this).select2({
        minimumResultsForSearch: Infinity,
        dropdownParent: $parent,
        width: '100%',
      });
    });

    // Haal de validatie-fout weg zodra een geldige optie wordt gekozen
    $('.order-line .return-reason-select').on('change', function () {
      let form = $(this).closest('form');
      let $unitContainer = $(this).closest('.order-line');
      let $select2Container = $unitContainer.find('.select2-selection');
      let $errorMsg = $unitContainer.find('.reason-error-message');
      let val = $(this).val();

      // AANGEPAST: We controleren nu simpelweg of er een waarde is ingevuld (en niet de placeholder/lege string)
      if (val && val !== '') {
        $select2Container.removeClass('reason-error');
        $errorMsg.hide();
      }

      updateReturnForm(form);
    });

    $('.order-line .return-unit-checkbox').on('change', function () {
      let form = $(this).closest('form');
      let $unitContainer = $(this).closest('.order-line');
      let $select2Container = $unitContainer.find('.select2-selection');
      let $errorMsg = $unitContainer.find('.reason-error-message');
      const isChecked = $(this).is(':checked');

      // Als de checkbox handmatig wordt uitgevinkt, halen we eventuele foutmeldingen weg
      if (!isChecked) {
        $select2Container.removeClass('reason-error');
        $errorMsg.hide();
      }

      updateReturnForm(form);
    });

    $('.order .return-cancel').click(function () {
      let form = $(this).closest('form');
      form.find('.return-unit-checkbox:not(:disabled)').prop('checked', false).trigger('change');
    });

    $('.order').each(function () {
      let form = $(this).closest('form');
      updateReturnForm(form);
    });

    // Validatie bij het indienen van het formulier
    $('.return-submit').on('click', function(e) {
      let form = $(this).closest('form');
      let hasError = false;
      let firstErrorElement = null;

      form.find('.order-line').each(function() {
        let $unitContainer = $(this);
        let $checkbox = $unitContainer.find('.return-unit-checkbox');
        let $reasonSelect = $unitContainer.find('.return-reason-select');
        let $select2Container = $unitContainer.find('.select2-selection');
        let $errorMsg = $unitContainer.find('.reason-error-message');

        if ($checkbox.is(':checked')) {
          let selectedValue = $reasonSelect.val();

          // AANGEPAST: Geen check meer op 'select-reason', enkel op leeg/null
          if (!selectedValue || selectedValue === '') {
            hasError = true;
            $select2Container.addClass('reason-error');
            $errorMsg.show();

            if (!firstErrorElement) {
              firstErrorElement = $unitContainer;
            }
          } else {
            $select2Container.removeClass('reason-error');
            $errorMsg.hide();
          }
        }
      });

      if (hasError) {
        e.preventDefault(); // Stop het versturen

        // Scroll soepel naar de eerste foutmelding op de pagina
        if (firstErrorElement) {
          $('html, body').animate({
            scrollTop: firstErrorElement.offset().top - 100,
          }, 400);
        }
        return false;
      }

      // Geen fouten? Dan pas de knop disablen en versturen
      setTimeout(() => {
        $(this).prop('disabled', true);
      }, 100);
    });
  },
  finalize() {
    // Any JS that should fire after init
  },
};

export var updateReturnForm = (form) => {
  let totalQuantity = 0;

  form.find('.order-line').each(function() {
    let $unitContainer = $(this);
    let $checkbox = $unitContainer.find('.return-unit-checkbox');
    let $reasonSelect = $unitContainer.find('.return-reason-select');

    let unitKey = $unitContainer.data('unit-key');

    if ($checkbox.is(':checked')) {
      totalQuantity += 1;
      form.find('.consolidated-qty-' + unitKey).val(1);

      // AANGEPAST: Alleen de waarde meesturen als deze daadwerkelijk is ingevuld
      let selectedVal = $reasonSelect.val();
      if (selectedVal && selectedVal !== '') {
        form.find('.consolidated-reason-' + unitKey).val(selectedVal);
      } else {
        form.find('.consolidated-reason-' + unitKey).val('');
      }
    } else {
      form.find('.consolidated-qty-' + unitKey).val(0);
      form.find('.consolidated-reason-' + unitKey).val('');
    }
  });

  let submitBar = form.find('.submit-bar');
  submitBar.find('.return-counter .counter').text(totalQuantity);

  if (totalQuantity > 0) {
    submitBar.slideDown();
  } else {
    submitBar.slideUp();
  }
};
